import script from "./RegionSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./RegionSelect.vue?vue&type=script&setup=true&lang=js"

import "./RegionSelect.vue?vue&type=style&index=0&id=46689762&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-46689762"]])

export default __exports__